import React from "react";

type OnSend = () => void | Promise<unknown>;

export function useEnterToSend(onSend: OnSend) {
  return React.useCallback(
    (event: React.KeyboardEvent) => {
      if (
        event.key !== "Enter" ||
        event.shiftKey ||
        event.nativeEvent.isComposing
      ) {
        return;
      }
      event.preventDefault();
      void onSend();
    },
    [onSend],
  );
}
